/** 세션 메모리: `#e:…` → 평문 라벨 (localStorage에 넣지 않음) */
const sealedLabelCache = new Map<string, string>();

export function getSealedTagLabelMap(): Record<string, string> {
  const out: Record<string, string> = {};
  sealedLabelCache.forEach((v, k) => {
    out[k] = v;
  });
  return out;
}

export function rememberSealedTagLabel(token: string, label: string): void {
  const t = (token ?? '').trim();
  const l = (label ?? '').trim();
  if (!t || !l) return;
  const raw = t.startsWith('#') ? t : `#${t}`;
  sealedLabelCache.set(raw, l);
}

export function peekSealedTagLabel(token: string): string | undefined {
  const t = (token ?? '').trim();
  if (!t) return undefined;
  const raw = t.startsWith('#') ? t : `#${t}`;
  return sealedLabelCache.get(raw);
}
